import { useMemo, useState } from 'react';
import { mangaList } from '@/mocks/mangaData';

const tabFilters = ['全部', '恋爱', '热血', '奇幻', '科幻', '悬疑', '治愈', '机战', '推理'];

export default function Trending() {
  const [active, setActive] = useState('全部');
  const [keyword, setKeyword] = useState('');

  const list = useMemo(() => {
    const kw = keyword.trim();
    return mangaList.filter((m) => {
      const matchTab = active === '全部' || m.category === active;
      const matchKw = !kw || m.title.includes(kw) || m.category.includes(kw);
      return matchTab && matchKw;
    });
  }, [active, keyword]);

  return (
    <section
      id="trending"
      className="bg-background-100/70 py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-semibold text-accent-700">
            <i className="ri-fire-line text-sm" />
            热门追更
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            大家都在追的佳作
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            收藏喜欢的作品，订阅更新提醒，热门新作第一时间送到你面前。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 lg:flex-row">
          <div className="flex flex-wrap justify-center gap-2">
            {tabFilters.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
                  active === tab
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="relative w-full lg:w-72">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品名称…"
              className="w-full rounded-full bg-background-50 py-2.5 pl-11 pr-4 text-sm text-foreground-950 ring-1 ring-background-200 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((m) => (
            <article
              key={m.id}
              className="group overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 transition-transform hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={m.cover}
                  alt={`${m.title} 漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <span className="rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-primary-700 backdrop-blur-sm">
                    {m.category}
                  </span>
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-semibold text-background-50 ${
                      m.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500'
                    }`}
                  >
                    {m.status}
                  </span>
                </div>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-foreground-800 backdrop-blur-sm">
                  <i className="ri-star-fill text-xs text-accent-500" />
                  {m.rating.toFixed(1)}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-[11px] text-white/90">{m.latestChapter}</span>
                </div>
              </div>

              <div className="p-4">
                <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
                  {m.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {m.description}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-team-line text-sm" />
                    {m.followers} 追
                  </span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className="ri-bookmark-line text-sm" />
                    收藏追更
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            没有找到相关作品，换个关键词试试吧。
          </p>
        )}
      </div>
    </section>
  );
}